<template>
  <div class="bg-white rounded">
    <div class="flex justify-between items-center px-4 pt-4">
      <slot name="Label" />

      <div class="flex items-center">
        <slot name="Actions" />
      </div>
    </div>

    <div class="p-4">
      <slot />
    </div>

    <footer v-if="$slots.Footer" class="p-4 border-t border-nano">
      <slot name="Footer" />
      <div class="btn">Normal</div>
      <div class="btn btn-primary">Primary</div>
      <div class="text-nano">Nano</div>
    </footer>
  </div>
</template>

<script src="./box.component.ts" lang="ts" />
